import { DataAttributeDefinitions } from 'scrivito'

import { pisaCompanyPersonRelationDataClass } from './Pisa/pisaCompanyPersonRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const CompanyPersonRelation =
  pisaCompanyPersonRelationDataClass(attributes)
